"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrimaryButton = PrimaryButton;
const components_1 = require("@alcumus/components");
const core_1 = require("@material-ui/core");
const react_1 = __importDefault(require("react"));
const useStyles = (0, core_1.makeStyles)(() => ({
    buttonBase: {
        borderRadius: 100,
        padding: '8px 24px',
    },
    buttonText: {
        fontWeight: components_1.StyleVariables.fonts.weight.semiBold,
        lineHeight: components_1.StyleVariables.fonts.lineHeight.h5,
    },
}));
function PrimaryButton({ id, text, ariaLabel, onClick, disabled, }) {
    const classes = useStyles();
    return (react_1.default.createElement(components_1.Button, { "aria-label": ariaLabel, uppercase: false, rounded: true, className: classes.buttonBase, size: "medium", disabled: disabled, "data-testid": id, id: id, onClick: (e) => onClick && onClick(e) },
        react_1.default.createElement(components_1.Text, { center: true, className: classes.buttonText }, text)));
}
